<template>
  <div class="payment">
    <v-countdown v-if="count_down" :count_down="count_down" position="checkout" no_reset="no_reset"></v-countdown>
    <v-shippingform :method="shipping_method" :user="user" :cart="cart" :service="myService"></v-shippingform>
    <div class="d-lg-none discount">
      <h4>{{$t('shopping.discount')}}</h4>
      <v-discountcode :getcoupons="coupons"></v-discountcode>
    </div>
    <div class="paymentbody">
      <h4>{{$t('shopping.payment')}}</h4>
      <p>{{$t('shopping.transactions')}}</p>
      <v-alert-tips  v-if="message" :message="message"></v-alert-tips>
      <div v-if="payment.length&&$store.state.news_cart.cart_total!='0'" class="paymentmethod">
        <div v-for="item in payment" :key="item.id"  :class="{[item.id]:true,'creditcard':availableCreditCardMethods.includes(item.id)}">
          <label>
            <input type="radio" name="payment_method"  v-model="billing.payment_method" :value="item.id" />
            <div :class="billing.payment_method==item.id?'checked dot':'dot'" v-show="payment.length>1"></div>
            <img  v-if="item.id=='ppec_paypal'" src="../../../../../public/images/paypal_new.png" alt />
            <span v-if="availableCreditCardMethods.includes(item.id)">{{$t('shopping.credit_card')}}</span>
            <v-payicon v-if="availableCreditCardMethods.includes(item.id)" :paylist="['Visa','Mastercard','Dicover','Diners Club International']" :wrapstyle="{'float':'right'}"></v-payicon>
          </label>
          <div v-if="item.id=='ppec_paypal'"  v-show="billing.payment_method==item.id" class="reminder">
            <img src="../../../../../public/images/bankcard.png" alt />
            <p>
              {{$t('shopping.paypal_tips')}}
            </p>
          </div>
          <div v-if="item.id=='custom-worldpay'||item.id=='xborderpay'"  v-show="billing.payment_method==item.id" class="reminder row">
            <div class="col-md-12 " :class="{'had_input':card.number,'required':error['card.number']}">
              <label for="number">{{$t('shopping.card_number')}}</label>
              <input type="text" :placeholder="$t('shopping.card_number')" id='number' v-model="card.number" @blur="required" @keyup.enter="complete">
              <span class="iconfont">&#xe644;</span>
              <div class="error_mes">{{$t('shopping.enter_valid_card')}}</div>
            </div>
            <div class="col-md-12 " :class="{'had_input':card.name,'required':error['card.name']}">
              <label for="name">{{$t('shopping.name_on_card')}}</label>
              <input type="text" :placeholder="$t('shopping.name_on_card')" id='name' v-model="card.name" @blur="required" @keyup.enter="complete">
              <div class="error_mes">{{$t('shopping.enter_name_on_card')}}</div>
            </div>
            <div class="col-md-6 " :class="{'had_input':worldPayData}">
              <label for="worldPayData">{{$t('shopping.expiration_date')}}</label>
              <input type="text" maxlength="7" :placeholder="$t('shopping.expiration_date')" id='worldPayData' v-model="worldPayData" @blur="required" @keyup.enter="complete">
              <div class="error_mes">{{$t('shopping.enter_card_date')}}</div>
            </div>
            <div class="col-md-6 " :class="{'had_input':card.cvc,'required':error['card.cvc']}">
              <label for="cvc">{{$t('shopping.security_code')}}</label>
              <input type="text" :placeholder="$t('shopping.security_code')" maxlength="4"  id='cvc' v-model="card.cvc" @blur="required" @keyup.enter="complete">
              <el-tooltip  effect="dark" placement="top" transition="abc">
                <div slot="content" class="text-center">
                  {{$t('shopping.3-digit_security_code')}} 
                  <br /> {{$t('shopping.on_the_back_of_your_card')}}
                </div>
                <button class="hint iconfont icon-wenhao1"></button>
              </el-tooltip>
              <div class="error_mes">{{$t('shopping.enter_cvv')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div  class="nopaymentmethod" v-else-if="$store.state.news_cart.cart_total=='0'">
        <div><svg width="151" height="80" viewBox="66 -30 151 80" enable-background="new 66 -30 151 80"><path stroke="#B3B3B3" stroke-width="2" d="M73.8-18.2c-4.4.8-7.3 4.9-6.5 9.3l7.6 43.3c.8 4.3 4.9 7.3 9.3 6.5l59.7-10.5c3.3-.6 7.4-3.3 9.1-6.1l14.4-22.5c2.4-3.7 1.5-8.9-2-11.6l-21.2-16.2c-2.6-2-7.4-3.2-10.7-2.6 0-.1-59.7 10.4-59.7 10.4z" fill="none"/><circle stroke="#B3B3B3" stroke-width="2" cx="157.2" cy="-2.9" r="3.5" fill="none"/><path stroke="#B3B3B3" stroke-width="2" d="M95.9 9.1l11.5 7.4 18-24.5M157.2-2.9c23.3-7.1 31.6 22.2 57.5-13.1" fill="none"/></svg>
          <p> {{$t('shopping.your_order_is_free')}}</p>
        </div>
      </div>
      <v-noavailable v-else :message="$t('shopping.no_payment')"></v-noavailable>
    </div>
    <div class="billingAddress">
      <h4>{{$t('shopping.billing_address')}}</h4>
      <p>{{$t('shopping.select_address')}}</p>
      <div class="billingAddressmethod">
        <label>
          <input type="radio" v-model="billingAddressmethod" value="same" />
          <div :class="billingAddressmethod=='same'?'checked dot':'dot'"></div>
          <i>{{$t('shopping.same_shipping_address')}}</i>
        </label>
        <label>
          <input type="radio" v-model="billingAddressmethod" value="different" />
          <div :class="billingAddressmethod=='different'?'checked dot ':'dot'"></div>
          <i>{{$t('shopping.use_billing_address')}}</i>
        </label>
        <div v-show="billingAddressmethod=='different'" class="row container shippingaddress">
          <v-checkoutaddressform1
            v-if="this.shipping.country!='JP'"
            :service="myService"
            :cart="cart"
            :address_book="address_book"
            :user="user"
            :checkout_address_2_config="checkout_address_2_config"
            :checkout_phone_config="checkout_phone_config"
            :addressBook="addressoption"
            :information="shipping"
            ref="addressform"
            :complete="complete"
            @upAddressBook="upAddressBook"
            @updataShipping="updataShipping"
            billing="billing"
          ></v-checkoutaddressform1>
          <v-checkoutaddressform2
            v-else
            :service="myService"
            :cart="cart"
            :address_book="address_book"
            :user="user"
            :checkout_address_2_config="checkout_address_2_config"
            :checkout_phone_config="checkout_phone_config"
            :addressBook="addressoption"
            :information="shipping"
            ref="addressform"
            :complete="complete"
            billing="billing"
            @upAddressBook="upAddressBook"
            @updataShipping="updataShipping"
          ></v-checkoutaddressform2>
        </div>
      </div>
    </div>
    <v-addressformfoot
      :toNext="$t('shopping.complete_order')"
      toPrev="shipping"
      :nothing="nothing"
      ref="addressformfoot"
      @toNextApi="complete"
    ></v-addressformfoot>
    <v-checkoutcommonfoot :blogname="blogname"></v-checkoutcommonfoot>
    <iframe  frameborder="0"  v-if="iframe_data" style="visibility: hidden;"  width='1px' height="1px" :srcdoc="iframe_data"></iframe>
  </div>
</template>
<script>
import vCheckoutaddressform1 from "./checkoutaddressform1";
import vCheckoutaddressform2 from "./checkoutaddressform2";
import vShippingform from "./shippingform";
import vDiscountcode from "./dicountcode";
import vCheckoutcommonfoot from "./checkoutcommonfoot";
import API from "../../../API";
import CountryStateJson from "../../../../assets/country_state.json";
import vAlertTips from "../../common/alerttips";
export default {
  props: [
    "cart",
    "user",
    "service",
    "pixel",
    "ga",
    "blogname",
    "address_book",
    "checkout_address_2_config",
    "checkout_phone_config",
    "count_down",
    "paypal_error",
    "preferred_payment_method"
  ],
  data() {
    return {
      myService:[],
      // 最终可用的付款方式
      payment: [],
      // 设置自己支持的付款方式
      availableMethods: ["ppec_paypal"],
      //自己设置的属于信用卡的方式，不放入availableMethods中，
      availableCreditCardMethods: ["custom-worldpay",'xborderpay','wc_asiabill_creditcard'],
      //自己设置的信用卡方式，和系统支持的信用卡方式都有的方式才是最终支持的方式，大于1是随机挑一个拼接到payment最前，
      creditCardMethods: [],
      // 选择的付款方式
      payment_method: "",
      // 获取到的配送方式
      shipping_method: "",
      billingAddressmethod: "same",
      province: "",
      nothing: false,
      coupons: [],
      shipping: {
        first_name: "",
        last_name: "",
        city: "",
        country: "",
        state: "",
        postcode: "",
        address_1: "",
        address_2: "",
        phone: null,
        email: "",
      },
      billing:{
        note:"",
        cart_hash:window.location.pathname.split('/')[2],
        payment_method:""
      },
      cart_hash:window.location.pathname.split('/')[2],
      addressoption: "newaddress",
      message:"",
      utm_medium:null,
      worldPayData:"",
      worldPay:{
        reusable: false,
        paymentMethod: {
            type: "Card",
            name: "",
            expiryMonth: "",
            expiryYear: "",
            cardNumber: "",
            cvc: ""
        },
        clientKey:''
      },
      card: {
        name: '',
        number: '',
        expiry_date: {
            month: '',
            year: ''
        },
        cvc: ""
      },
      error:{},
      text_required_item:['number','name','worldPayData','cvc'],
      focusOff : true,
      worldpay_api_err:['number','Name','Month','Year','Expiry date','CVC'],
      creditCardNum:0,//可用信用卡方式数量
      iframe_data:"",
    };
  },
  methods: {
    focusMethod(ID) {
      if (this.focusOff) {
          this.$("#" + ID).focus();
      }
      this.focusOff = false;
    },
    text_required(){
      let value=true;
      this.text_required_item.forEach(item=>{
        if(item=='worldPayData'&&this.worldPayData.length<5){
          console.log(this.worldPayData);
            this.$("#" + item)
            .parent()
            .addClass("required");
            value = false;
            this.focusMethod(item);
        }else if(item!=='worldPayData'&&!this.card[item]){
            this.$("#" + item)
            .parent()
            .addClass("required");
            value = false;
            this.focusMethod(item);
        }
      })
      this.focusOff = true;
      return value;
    },
    required(e) {
      if (e.target.value.trim() == "") {
        this.$(e.target.parentNode).addClass("required");
      } else {
        this.$(e.target.parentNode).removeClass("errormes");
        this.$(e.target.parentNode).removeClass("required");
      }
    },
    upAddressBook(upAddressBook) {
      this.addressoption = upAddressBook;
      console.log("addressoption", this.addressoption);
    },
    updataShipping(information) {
      console.log("information", information);
      this.shipping = information;
    },
    async complete() {
      this.$refs.addressformfoot.active = true;
      var value =
        this.billingAddressmethod == "same"
          ? true
          : this.$refs.addressform.toshipping();
      if (this.billing.payment_method=='custom-worldpay'||this.billing.payment_method=='xborderpay') {
        this.billing.card=this.card;
        let onOff = this.text_required();
        if(value){
          value=onOff;
        }
      }else{
        delete(this.billing['card']);
      }
      if ((this.billing.payment_method||!this.payment.length )&& value) {
        this.error = {};
        this.$refs.addressform.error = {};
        // if(this.billing.payment_method=='online_worldpay'){
        //   if(!this.text_required()){
        //     this.$refs.addressformfoot.active = false;
        //     return
        //   }
        //   try {
        //     let res=await this.$axios.post(API.worldpay,this.worldPay);
        //     this.billing.online_worldpay_payment_nonce=res.data.token;
        //   } catch (error) {
        //     this.message=error.response.data.message;
        //     this.$refs.addressformfoot.active = false;
        //     this.worldpay_api_err.forEach(item=>{
        //       if(error.response.data.message.includes(item)){
        //         let id=null;
        //         switch (item) {
        //             case 'number':
        //               id='cardNumber';
        //               break;
        //             case 'Name':
        //               id='name';
        //               break;
        //             case 'Month':
        //             case 'Year':
        //               id='worldPayData';
        //               break;
        //             case 'CVC':
        //               id='cvc';
        //               break;
        //           }
        //         this.$("#"+id).parent().addClass("required");
        //         this.focusMethod(id);
        //       }
        //     })
        //     return;
        //     Sentry.captureException(error);
        //   }
        // }else{
        //   delete(this.billing['online_worldpay_payment_nonce']);
        // }
        // try {
        //   let payment_data={
        //     cart_hash:this.cart_hash,
        //     payment_method: this.payment_method,
        //   };
          this.utm_medium=this.getSearch('utm_medium');
        //   if(this.utm_medium){
        //     payment_data.utm_medium=this.utm_medium;
        //   }
        //   let res = await this.$axios.post(API.set_payment, payment_data);
          try {
            if(this.billingAddressmethod == "different"){
              this.billing.billing=this.shipping;
              sessionStorage.setItem('billingAddress',JSON.stringify(this.shipping));
            }else{
              delete(this.billing['billing']);
            }
            if(this.utm_medium){
              this.billing.utm_medium=this.utm_medium;
            }
            let result = await this.$axios.post(API.checkout, this.billing);
            // 发起修改购买信息事件
            if (window.fbq) {
              window.fbq("track", "AddPaymentInfo", {
                value: this.cart.cart_total,
                currency: this.cart.currency ? this.cart.currency : "USD",
              });
            }
            if (window.gtag) {
              window.gtag("event", "add_payment_info");
            }
            console.log(result);
            setTimeout(() => {
              this.$refs.addressformfoot.active = false;
            }, 5000);
            if(result.data.redirect_type==='html'){
              this.iframe_data=result.data.redirect;
            }else{
              window.open(result.data.redirect, "_self");
            }
          } catch (error) {
            if (!this.$("title")[0].innerText.includes("Error")) {
              this.$("title")[0].innerText =
                "Error - " + this.$("title")[0].innerText;
            }
            console.log(error.response);
            if (error.response.data.status_code == 422) {
              this.error=error.response.data.errors;
              this.$refs.addressform.error = error.response.data.errors;
              let error_id = Object.keys(error.response.data.errors);
              if(error_id[0].includes('billing.')){
                error_id = error_id[0].replace("billing.", "");
                this.$refs.addressform.focusMethod(error_id);
              }else if(error_id[0].includes('card.')){
                error_id = error_id[0].replace("card.", "");
                this.focusMethod(error_id);
              }
            } else if(error.response&&error.response.data&&error.response.data.message) {
              this.message=error.response.data.message;
            }
            this.$store.dispatch("change_update_cart", true);
            this.$refs.addressformfoot.active = false;
            // Sentry.captureException(error);
          }
        // } catch (error) {
        //   this.$store.dispatch("change_update_cart", true);
        //   this.$refs.addressformfoot.active = false;
        //   console.log(error.response);
        //   if (error.response.status == 422) {
        //     this.$message.error("Please choose the method of payment");
        //   } else if(error.response&&error.response.data&&error.response.data.message) {
        //       this.message=error.response.data.message;
        //   }
        //   Sentry.captureException(error);
        // }
      } else if(!this.billing.payment_method) {
        // 加强用户提示
         this.$message.error("Please choose the method of payment");
         this.$refs.addressformfoot.active = false;
      }else{
        this.$refs.addressformfoot.active = false;
      }
    },
    has_payment(){
      // 如果最终有这种付款方式则可用
      // let payment_on=this.payment.some((item) => {
      //   if (item.id == this.cart.payment.chosen_method) {
      //     this.billing.payment_method = this.cart.payment.chosen_method;
      //     return true;
      //   }
      // });
      // 如果已选择的付款方式不存在，则改为使用第一个
      // 由于初始化时已选支付方式始终为可用付款第一个，所以无视已选付款方式，始终使用后台推荐的付款方式
      if(this.payment.length){
          this.billing.payment_method=this.payment[0].id;
      }else{
          this.billing.payment_method=""
      }
    },
    getPayment(newCart){
      this.payment=[];
      // 自己支持的付款方式和系统支持的付款方式都有,并且不属于信用卡的方式的才是可选的付款方式
      this.availableMethods.forEach((item) => {
        newCart.payment.methods.some((subitem) => {
          if (item == subitem.id&&!this.availableCreditCardMethods.includes(subitem.id)) {
            this.payment.push(subitem);
            return true;
          }
        });
      });
      //自己支持的信用卡付款方式和系统支持的付款方式都有的才是可选的付款方式，添加进creditCardMethods做为备选
      this.availableCreditCardMethods.forEach(item=>{
        newCart.payment.methods.some((subitem) => {
          if (item == subitem.id) {
            this.creditCardNum++;
            this.creditCardMethods.push(subitem);
            return true;
          }
        });
      })
      // 信用卡可用大于0时随机挑一种信用卡方式添加到this.payment最前;
      if(this.creditCardNum>0){
        let randomNum=Math.floor(Math.random()*this.creditCardNum);
        //若后台配置preferred_payment_method为信用卡则unshift到第一个
        if(this.preferred_payment_method=="credit_card"){
          this.payment.unshift(this.creditCardMethods[randomNum]);
        }else{
          this.payment.push(this.creditCardMethods[randomNum]);
        }
      }
      // 判断当前已选中的付款方式是否可用，若不可用则选中当前可用的第一个;
      this.has_payment();
    }
  },
  beforeMount() {
    this.$store.dispatch("change_news_cart", this.cart);
    if(this.paypal_error){
      this.message=this.paypal_error;
    }
    this.myService=this.concatCounty(this.service,CountryStateJson);
    // window.addEventListener(
    //   "pageshow",
    //   () => {
    //     this.$refs.addressformfoot.active = false;
    //   },
    //   false
    // );
    console.log(this.cart);
    this.coupons = Object.values(this.cart.coupons);
    // 获取已选的配送方式的id和可用配送方式的id做比对 将配送方式名称传出
    this.cart.shipping.methods.forEach((item) => {
      if (item.id == this.cart.shipping.chosen_method) {
        this.shipping_method = item;
      }
    });
    this.getPayment(this.cart);
    // this.nothing = !this.payment.length;
    if (this.cart.billing_address.first_name) {
      this.shipping = this.cart.billing_address;
      //判断用户使用过的地址是否有匹配的地址薄的地址
      if (this.address_book.length) {
        this.address_book.some((item) => {
          if (
            this.shipping.first_name == item.first_name &&
            this.shipping.last_name == item.last_name &&
            this.shipping.city == item.city &&
            this.shipping.country == item.country &&
            this.shipping.state == item.state &&
            this.shipping.postcode == item.postcode &&
            this.shipping.address_1 == item.address_1 &&
            this.shipping.phone == item.phone
          ) {
            this.addressoption = JSON.stringify(item);
            return true;
          }
        });
      }
    } else if (this.address_book.length) {
      this.address_book.some((item) => {
        if (item.default) {
          this.shipping = item;
          this.addressoption = JSON.stringify(item);
          return true;
        }
      });
    }
    // 浏览器回退时获取选择的付款方式和账单地址
    let  billingAddressmethod= sessionStorage.getItem('billingAddressmethod');
    let  billingAddress= sessionStorage.getItem('billingAddress');
    let  payment_method=sessionStorage.getItem('payment_method');
    let  creditcard=sessionStorage.getItem('creditcard');
    let  worldPayData=sessionStorage.getItem('worldPayData');
    if (window.performance.navigation.type == 2 && worldPayData) {
      this.worldPayData=worldPayData;
    }
    if (window.performance.navigation.type == 2 && creditcard) {
      this.card=JSON.parse(creditcard);
      console.log(' this.creditcard',this.card);
    }
    if (window.performance.navigation.type == 2 && payment_method) {
      this.billing.payment_method=payment_method;
      this.has_payment();
    }
    if (window.performance.navigation.type == 2 && billingAddressmethod) {
      this.billingAddressmethod=billingAddressmethod;
      console.log(' this.billingAddressmethod',this.billingAddressmethod);
    }
    if (window.performance.navigation.type == 2 && billingAddress) {
      this.shipping = JSON.parse(billingAddress);
      console.log(' this.billingAddress',this.billingAddress);
    }
  },
  components: {
    vShippingform,
    vDiscountcode,
    vCheckoutcommonfoot,
    vCheckoutaddressform1,
    vCheckoutaddressform2,
    vAlertTips
  },
  watch:{
    '$store.state.news_cart':{
      handler(newV){
        this.getPayment(newV);
      },
      deep:true
    },
    'billing.payment_method':{
      handler(newV){
        sessionStorage.setItem('payment_method',newV);
      },
      deep:true
    },
    billingAddressmethod(newV){
        sessionStorage.setItem('billingAddressmethod',newV);
    },
    card:{
       handler (newV) {
         sessionStorage.setItem('creditcard',JSON.stringify(newV));
       },
       deep: true
    },
    'card.number':{
      handler (newV) {
        this.card.number=newV.replace(/[\D]/g, "");
       },
       deep: true
    },
    'card.cvc':{
      handler (newV) {
        this.card.cvc=newV.replace(/[\D]/g, "");
       },
       deep: true
    },
    worldPayData(newV,oldV){
      sessionStorage.setItem('worldPayData',JSON.stringify(newV));
      newV=newV.replace(/[\D]/g, "");
      if(newV.length==1&&newV>1){
        newV='0'+newV;
      }
      if(oldV.length==3&&newV.length==2){
        return;
      }
      this.worldPayData=newV.replace(/(\d{2})/, '$1/');
      let date_obj= this.worldPayData.split('/');
      console.log(date_obj);
      this.card.expiry_date.month=date_obj[0];
      this.card.expiry_date.year=date_obj[1];
      console.log(this.worldPay.paymentMethod);
    },
    'message'(){
     this.$('html,body').animate({scrollTop:$('.paymentbody').offset().top}, 200);
    }
  }
};
</script>
<style scoped lang='scss'>
.payment {
  h4 {
    font-size: 18px;
    color: #333;
    margin: 0;
  }

  p {
    font-size: 12px;
    margin-top: 3.5px;
    margin-bottom: 0;
    color: #545454;
  }

  .discount {
    padding-top: 42px;
  }

  .paymentbody {
    padding-top: 42px;

    .paymentmethod {
      margin-top: 24px;
      border: 1px solid #d9d9d9;
      border-radius: 5px;
      overflow: hidden;

  
      .ppec_paypal{
        label{
          img {
            vertical-align: top;
            height: 22px;
          }
        }
        .reminder{
          padding: 32px 59px;
          img {
            width: 163px;
            height: 81px;
            margin-bottom: 16px;
          }
        }
      }
      .creditcard{
        label{
          span{
            color:#333;
            font-weight: 600;
          }
        }
        .reminder{
          margin-right: -6px;
          margin-left: -6px;
          &>div{
            padding: 6px !important;
           label {
              color: #737373;
              display: none;
              font-size: 13px;
              position: absolute;
              top: 8px;
              left: 18px;
              z-index: 10;
            }
            input{
              width: 100%;
              color: #333333;
              outline: none;
              font-size: 14px;
              height: 46px;
              position: relative;
              border-radius: 5px;
              padding: 13px 11px;
              border: 1px solid #d9d9d9;
              &:focus {
                outline: none;
                box-shadow: 0 0 0 1px #128fae ;
                border-color: #0f88a7;
                border-radius: 5px;
              }
            }
            input[type=number] {
                -moz-appearance:textfield;
            }
            input[type=number]::-webkit-inner-spin-button,
            input[type=number]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            .iconfont{
              position: absolute;
              top: 15px;
              right: 15px;
              font-size: 21px;
              color: #919191;
            }
            .hint {
              position: absolute;
              top: 16px;
              right: 6px;
              border: none;
              background: rgba(255, 255, 255, 0);
              padding: 0 10px;
              height: 26px;
              line-height: 26px;
              color: #919191;
              font-size: 20px;
            }
            .error_mes{
                display: none;
                margin: 8px 0 4px;
                color: #e9004c;
                font-size: 14px;
                text-align: left;
             }
          }
          &>.had_input{
            input {
              padding: 21px 29px 5px 11px !important;
            }
            label {
              display: inline-block !important;
            }
          }
          &>.required{
            input{
              border-color: #e32c2b !important;
              box-shadow: 0 0 0 1px #e32c2b !important;
              &:focus {
                box-shadow: 0 0 0 1px #e32c2b !important;
                border-color: #e32c2b !important;
              }
            }
            .error_mes{
              display: block;
            }
          }
        }
      }
      .reminder {
        text-align: center;
        padding: 16px;
        background: #fafafa;
        border-top: 1px solid #d9d9d9;
        font-size: 14px;
      }
      &>div>label {
        padding: 16px;
        width: 100%;
        cursor: pointer;
        font-size: 14px;
        margin: 0;

        input {
          display: none;
        }

        .checked {
          background: #0f88a7 !important;
        }
        span {
          display: inline-block;
        }

        .dot {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-right: 10.5px;
          line-height: 18px;
          border-radius: 50%;
          text-align: center;
          background: white;
          border: 1px solid #d9d9d9;

          &:after {
            content: "";
            vertical-align: middle;
            display: inline-block;
            margin-top: -5px;
            width: 5px;
            height: 5px;
            background: white;
            border-radius: 50%;
          }
        }
      }

      & > div:not(:first-child) {
       &>label {
          border-top: 1px solid #d9d9d9;
        }
      }
    }

    .nopaymentmethod {
      margin-top: 10px;
      padding: 16px 63px;
      font-size: 16px;
      text-align: center;
      border: 1px solid #d9d9d9;
      border-radius: 5px;
      color: #545454;
      div{
        padding: 16px;
        svg{
          margin-bottom: 16px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }

  .billingAddress {
    margin-top: 42px;

    .billingAddressmethod {
      border: 1px solid #d9d9d9;
      border-radius: 5px;

      label {
        width: 100%;
        padding: 16px;
        cursor: pointer;
        font-size: 14px;
        margin: 0;

        input {
          display: none;
        }

        .checked {
          background: #0f88a7 !important;
        }

        .dot {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-right: 10.5px;
          line-height: 18px;
          border-radius: 50%;
          text-align: center;
          background: white;
          border: 1px solid #d9d9d9;

          &:after {
            content: "";
            vertical-align: middle;
            display: inline-block;
            margin-top: -5px;
            width: 5px;
            height: 5px;
            background: white;
            border-radius: 50%;
          }
        }

        & > i {
          font-size: 14px;
          font-weight: 600;
          color: #545454;
        }
      }

      & > label:not(:first-child) {
        border-top: 1px solid #d9d9d9;
      }

      .shippingaddress {
        padding: 10px !important;
        border-top: 1px solid #d9d9d9;
        background-color: #fafafa;
        margin: 0;

        & > div {
          padding: 6px;
          position: relative;

          select,
          input {
            width: 100%;
            font-size: 12px;
            padding: 21px 11px 5px;
            border: 1px solid #d9d9d9;
            border-radius: 5px;
          }

          select {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }

          select:focus,
          input:focus {
            outline: none;
            border: 2px solid #128fae;
            padding: 20px 10px 4px;
            border-radius: 5px;
          }

          span {
            font-size: 12px;
            position: absolute;
            top: 7px;
            left: 20px;
          }

          i {
            font-size: 12px;
            position: absolute;
            top: 20px;
            right: 20px;
          }
        }
      }
    }
  }

  .addressfoot {
    margin-top: 15px;

    button {
      font-size: 14px;
      padding: 20px 24px;
      width: 100%;
      border: none;
      background: #0f88a7;
      color: white;
      border-radius: 5px;
    }

    a {
      height: 61px;
      text-decoration: none;
      color: #0f88a7;
      font-size: 14px;
    }
  }
}
.abc-enter-to,
.abc-leave {
  transition: all 0.2s linear;
  opacity: 1;
  transform: scale(1);
}

.abc-enter,
.abc-leave-to {
  transition: all 0.2s linear;
  opacity: 0;
  transform: scale(0.8);
}

@media screen and (max-width: 992px) {
  .payment {
    .paymentbody {
      padding-top: 21px;
    }
  }
}

* {
  font-style: normal;
}

.icon {
  width: 90px;
  height: 24px;
  overflow: hidden;
}
</style>